import React from 'react';
import styled from 'styled-components';

import GroupIcon from '../../../components/UI/Icon-SVG/GroupIcon';
import ProfileIconSmall from '../../../components/UI/Icon-SVG/ProfileIconSmall';

const CustomHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #f8f8fb;
  padding: 0px 16px;
  width: 100% !important;
  height: 64px;
  border-bottom: 1px solid #d7def3;
`;

const Title = styled.h3`
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 0;
  margin-right: 10px;
`;

const IconWrap = styled.div`
  background: #397ef3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  margin-right: 16px;
`;

const MessageListHeader = ({ selectedChatName, isGroupChat }) => (
  <CustomHeader>
    <IconWrap>{isGroupChat ? <GroupIcon /> : <ProfileIconSmall />}</IconWrap>
    <Title>{selectedChatName}</Title>
  </CustomHeader>
);

export default MessageListHeader;
